// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1lVlR","colBig":"styles_colBig__3ggUV","colSmall":"styles_colSmall__1bH2-"};